import { inject, Service } from '@angular/core';
import { CurrentConfigurator } from '@portal-core/current/services/current-module-config.interface';
import { LicenseUser } from '@portal-core/license-users/models/license-user.model';
import { License } from '@portal-core/licenses/models/license.model';
import { CoreService } from '@portal-output/core/services/core.service';
import { Observable } from 'rxjs';

@Service()
export class CurrentConfiguratorService implements CurrentConfigurator {
  private readonly coreService = inject(CoreService);

  getLicenseUser(): LicenseUser {
    return this.coreService.getLicenseUser();
  }

  getLicenseUser$(): Observable<LicenseUser> {
    return this.coreService.getLicenseUser$();
  }

  getLicense(): License {
    return this.coreService.getLicense();
  }

  getLicense$(): Observable<License> {
    return this.coreService.getLicense$();
  }

  getActiveLicense(): License {
    return this.coreService.getActiveLicense();
  }

  getActiveLicense$(): Observable<License> {
    return this.coreService.getActiveLicense$();
  }

  isSysAdmin(): boolean {
    return false;
  }
}
